export default "/images/ic-brodcart-a.svg?2daedfeee07012d1b5b439b113ab2c0f";